if (!customElements.get('complementary-products')) {
  customElements.define('complementary-products', class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.cart = document.querySelector('cart-drawer');
      this.isProcessing = false;

      /* -------------------------------------------------------
       * VARIANT / SIZE SELECTS
       * ----------------------------------------------------- */
      this.querySelectorAll('.select__select, input.complementary-variant-id[data-available="true"]').forEach(el => {
        el.addEventListener('change', this.onVariantChange.bind(this));
      });

      /* -------------------------------------------------------
       * QUANTITY INPUTS
       *   — власний обробник на input + change
       *   — НЕ чіпаємо .quantity__button, щоб не дублювати «+1»
       * ----------------------------------------------------- */
      this.querySelectorAll('.quantity__input').forEach(input => {
        input.addEventListener('input', this.onQuantityInput.bind(this));
        input.addEventListener('change', this.onQuantityInput.bind(this)); // реагує на "плюс/мінус" з теми
      });

      /* -------------------------------------------------------
       * ADD‑TO‑CART BUTTONS
       * ----------------------------------------------------- */
      this.querySelectorAll('.complementary__add-btn').forEach(btn => {
        btn.addEventListener('click', this.onAddToCartClick.bind(this));
      });

      // Touch scroll + desktop nav
      this.initTouchScroll();
      this.initNavigation();
    }

    /* =======================================================
       VARIANT CHANGE
       ===================================================== */
    onVariantChange(evt) {
      if (!evt || !evt.target.classList.contains('select__select')) return;

      const item           = evt.target.closest('.complementary__item');
      const selectedOption = evt.target.querySelector('option:checked');
      const priceEl        = item.querySelector('.price');

      this.updatePrice(
        priceEl,
        parseInt(selectedOption.dataset.price),
        parseInt(selectedOption.dataset.compareAtPrice)
      );

      // Update image if variant has its own
      const imgTag = item.querySelector('img');
      if (selectedOption.dataset.featuredImage) {
        const baseSrc   = selectedOption.dataset.featuredImage;
        const imgWidth  = parseInt(selectedOption.dataset.featuredImageWidth);
        const breakpts  = [275, 550, 710, 1420];
        const srcset    = breakpts
          .filter(w => imgWidth >= w)
          .map(w => `${baseSrc}&width=${w} ${w}w`) // 1x variants
          .concat(`${baseSrc} ${imgWidth}w`)
          .join(',');
        imgTag.srcset = srcset;
        imgTag.classList.add('use-variant-image');
      } else if (imgTag.classList.contains('use-variant-image')) {
        imgTag.srcset = item.dataset.featuredImage;
        imgTag.classList.remove('use-variant-image');
      }
    }

    /* =======================================================
       QUANTITY INPUT (input & change)
       ===================================================== */
    onQuantityInput(evt) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      const input  = evt.target;
      let value    = parseInt(input.value) || 1;
      if (value < 1) value = 1;
      input.value  = value;

      this.updateAddButtonState(input);
      setTimeout(() => {
        this.isProcessing = false;
      }, 150);
    }

    /* -------------------------------------------------------
       ENABLE / DISABLE ADD BUTTON
       ----------------------------------------------------- */
    updateAddButtonState(quantityInput) {
      const item      = quantityInput.closest('.complementary__item');
      const addButton = item.querySelector('.complementary__add-btn');
      const qty       = parseInt(quantityInput.value) || 0;

      if (qty > 0) addButton.removeAttribute('disabled');
      else         addButton.setAttribute('disabled', 'disabled');
    }

    /* =======================================================
       ADD TO CART
       ===================================================== */
    onAddToCartClick(evt) {
      evt.preventDefault();

      const btn           = evt.currentTarget;
      if (btn.hasAttribute('disabled')) return;

      const item          = btn.closest('.complementary__item');
      const quantityInput = item.querySelector('.quantity__input');
      const variantSel    = item.querySelector('.complementary-variant-id');
      const qty           = parseInt(quantityInput.value) || 0;
      if (!qty) return;

      const variantId = variantSel.value;
      this.addSingleProductToCart(variantId, qty, btn, item);
    }

    addSingleProductToCart(variantId, qty, btn, item) {
      // Disable + spinner on ALL add buttons in the same card
      const addBtns = item.querySelectorAll('.complementary__add-btn');
      addBtns.forEach(b => {
        b.setAttribute('disabled', 'disabled');
        b.classList.add('loading');
        b.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      });

      const cfg = fetchConfig('javascript');
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete cfg.headers['Content-Type'];

      const fd = new FormData();
      fd.append('items[0][id]',       variantId);
      fd.append('items[0][quantity]', qty);

      if (this.cart) {
        fd.append('sections',     this.cart.getSectionsToRender().map(s => s.id));
        fd.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      cfg.body = fd;

      fetch(`${routes.cart_add_url}`, cfg)
        .then(r => r.json())
        .then(r => {
          if (r.status) {
            this.handleErrorMessage(r.description);
            return;
          }
          if (!this.cart) { window.location = routes.cart_url; return; }
          this.cart.renderContents(r);

          // Reset qty inputs inside this card
          item.querySelectorAll('.quantity__input').forEach(inp => inp.value = 1);
          this.updateAddButtonState(item.querySelector('.quantity__input'));
        })
        .catch(err => {
          console.error(err);
          this.handleErrorMessage('An error occurred while adding the product to cart.');
        })
        .finally(() => {
          addBtns.forEach(b => {
            b.classList.remove('loading');
            b.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            b.removeAttribute('disabled');
          });
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        });
    }

    /* =======================================================
       HELPERS (price / errors) — unchanged
       ===================================================== */
    updatePrice(priceEl, price, compareAt, noConvert) {
      priceEl?.update?.(price, compareAt, noConvert);
    }

    handleErrorMessage(msg = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !msg);
      if (msg) this.errorMessage.textContent = msg;
    }
    

    // Улучшенный скролл для мобильных устройств
    initTouchScroll() {
      const productList = this.querySelector('.complementary__product-list');
      if (!productList) return;

      // Только для мобильных устройств
      if (window.innerWidth > 749) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let startTime;
      let velocity = 0;

      // Touch события для snap-to-card
      productList.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - productList.offsetLeft;
        scrollLeft = productList.scrollLeft;
        startTime = Date.now();
        velocity = 0;
      });

      productList.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.touches[0].pageX - productList.offsetLeft;
        const walk = (x - startX) * 1.5;
        productList.scrollLeft = scrollLeft - walk;
        
        // Вычисляем скорость для инерции
        const now = Date.now();
        velocity = walk / (now - startTime);
        startTime = now;
      });

      productList.addEventListener('touchend', () => {
        if (!isDown) return;
        isDown = false;
        
        // Snap to nearest card
        this.snapToNearestCard(productList, velocity);
      });

      // Также обрабатываем обычный скролл для snap эффекта
      let scrollTimeout;
      productList.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (!isDown) { // Только если не идет touch
            this.snapToNearestCard(productList, 0);
          }
        }, 150);
      });
    }

    // Функция для snap к ближайшей карточке
    snapToNearestCard(productList, velocity = 0) {
      const cardWidth = productList.children[0]?.offsetWidth + 16 || 300; // Ширина карточки + gap
      const currentScroll = productList.scrollLeft;
      
      // Определяем к какой карточке прижиматься
      let targetCard = Math.round(currentScroll / cardWidth);
      
      // Учитываем инерцию/скорость для более естественного поведения
      if (Math.abs(velocity) > 0.5) {
        if (velocity < 0) targetCard++; // Свайп влево
        if (velocity > 0) targetCard--; // Свайп вправо
      }
      
      // Ограничиваем границы
      targetCard = Math.max(0, Math.min(targetCard, productList.children.length - 1));
      
      const targetScroll = targetCard * cardWidth;
      
      productList.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    // Навигация стрелками для десктопа
    initNavigation() {
      const productList = this.querySelector('.complementary__product-list');
      const prevBtn = this.querySelector('.complementary__nav-btn--prev');
      const nextBtn = this.querySelector('.complementary__nav-btn--next');

      if (!productList || !prevBtn || !nextBtn) return;

      // Только для десктопа
      if (window.innerWidth <= 749) return;

      const scrollAmount = 340; // Ширина одной карточки + gap (320px + 20px)

      prevBtn.addEventListener('click', () => {
        productList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        productList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      // Обновляем состояние кнопок при скролле
      const updateButtons = () => {
        const scrollLeft = productList.scrollLeft;
        const scrollWidth = productList.scrollWidth;
        const clientWidth = productList.clientWidth;
        
        prevBtn.disabled = scrollLeft <= 5;
        nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 5;
      };

      productList.addEventListener('scroll', updateButtons);
      
      // Также обновляем при изменении размера окна
      window.addEventListener('resize', () => {
        setTimeout(updateButtons, 100);
      });

      // Инициализируем состояние кнопок
      setTimeout(updateButtons, 100);
    }
  });
}